<template>
  <section id="all-emr-orders-view" class="all-cases-view">
    <div class="container-default">
      <div class="listings-navbar">
        <el-row>
          <el-col :lg="7">
            <ul class="d-flex list-items-group-15 barcode-print">
              <li>
                <div class="form-element input-with-icon search-input-lg">
                  <el-input placeholder="Accession / EMR / Patient Name" v-model="search_string"
                    @input="getAutoCompleteOrders()" :clearable="true" suffix-icon="el-icon-date"></el-input>
                  <span>
                    <img src="@/assets/images/icons/search-icon-with-bg-red.svg" alt="icon" class="img-fluid icon" />
                  </span>
                </div>
              </li>
            </ul>
          </el-col>
        </el-row>
      </div>

      <div class="primary-content-view" v-loading="loading">
        <div class="listings listings__table listings__all-cases" id="all-cases-listings">
          <el-table :data="getFailedEmrOrders.data" height="calc(100vh - 200px)" :default-sort="{
            prop: orderBy,
            order: orderType == 'asc' ? 'ascending' : 'descending',
          }" @sort-change="onChangeSort" @selection-change="handleSelectionChange($event)">
            <el-table-column label="EMR" width="150" fixed="left">
              <template #default="scope">
                <div class="emr-id" v-if="scope.row.patient_info">
                  <span @click="goToViewOrders(scope.row._id)" class="cursor">
                    {{
                      scope.row.patient_info.emr
                        ? scope.row.patient_info.emr
                        : "--"
                    }}
                  </span>
                </div>
              </template>
            </el-table-column>
            <el-table-column label="Case Type" width="125px" prop="case_types" sortable="custom" fixed="left">
              <template #default="scope">
                <div class="case-type" v-if="scope.row.case_types && scope.row.case_types.length > 1">
                  <el-dropdown>
                    <span class="case-data-type">
                      {{ getCaseTypes(scope.row.case_types)[0] }}

                      <img src="@/assets/images/case-type-arrow.svg" alt="icon" />
                    </span>

                    <template #dropdown>
                      <el-dropdown-menu class="case-type-dropdown">
                        <el-dropdown-item class="cases-view" v-for="(caseType, index) of getCaseTypes(
                          scope.row.case_types
                        )" :key="index">
                          {{ caseType }}
                        </el-dropdown-item>
                      </el-dropdown-menu>
                    </template>
                  </el-dropdown>
                </div>
                <div v-else-if="
                  scope.row.case_types && scope.row.case_types.length == 1
                " class="case-type">
                  <span class="case-data-type">
                    {{ getCaseTypes(scope.row.case_types)[0] }}
                  </span>
                </div>
                <div v-else></div>
              </template>
            </el-table-column>
            <el-table-column prop="patient_info.first_name" label="PATIENT NAME" width="150" sortable="custom"
              fixed="left">
              <template #default="scope">
                <el-button placement="top" class="title-on-hover"
                  :title="convertToUppercase(getPatientNameByInfo(scope.row.patient_info))" @click="
                    copyTitle(getPatientNameByInfo(scope.row.patient_info))
                    ">
                  <span class="text-center ordering_facility-value">{{
                    convertToUppercase(getPatientNameByInfo(scope.row.patient_info))
                    }}</span>
                </el-button>
              </template>
            </el-table-column>
            <el-table-column label="Patient DOB" width="130">
              <template #default="scope">
                <div style="cursor: default;">
                {{ formatDate(scope.row.patient_info.date_of_birth) }}
                </div>
              </template>
            </el-table-column>
            <el-table-column label="CREATED ON" width="130" prop="created_at" sortable="custom">
              <template #default="scope">
                <div v-if="scope.row.created_at" class="d-flex">
                  <div style="cursor: default;" class="date pr-10">
                    {{ momentWithTimezone(scope.row.created_at, "MM-DD-yyyy") }}
                  </div>
                </div>
              </template>
            </el-table-column>

            <el-table-column prop="hospital" label="ORDERING FACILITIES" min-width="200">
              <template #default="scope">
                <el-button placement="top" class="title-on-hover"
                  :title="scope.row.hospital ? scope.row.hospital.name : '--'">
                  <span class="ordering_facility-value">{{
                    scope.row.hospital ? scope.row.hospital.name : "--"
                    }}</span>
                </el-button>
              </template>
            </el-table-column>

            <el-table-column label="PHYSICIAN" min-width="150">
              <template #default="scope">
                <el-button placement="top" class="title-on-hover" :title="scope.row.ordering_physician
                    ? scope.row.ordering_physician.name.includes('Dr')
                      ? scope.row.ordering_physician.name
                      : 'Dr ' + scope.row.ordering_physician.name
                    : '--'
                  ">
                  {{
                    scope.row.ordering_physician
                      ? scope.row.ordering_physician.name.includes("Dr")
                        ? scope.row.ordering_physician.name
                        : "Dr " + scope.row.ordering_physician.name
                      : "--"
                  }}
                </el-button>
              </template>
            </el-table-column>

            <el-table-column label="Status" width="130" prop="status" sortable="custom">
              <template #default="scope">
                <div class="column-status" v-if="scope.row.status">
                  <span class="el-dropdown-link" v-if="scope.row.status == 'COMPLETED'">
                    <el-tag style="cursor: default;" :type="getStatusType(scope.row.status)">FINALIZED</el-tag>
                  </span>
                  <span class="el-dropdown-link" v-else-if="scope.row.status == 'CANCELLED'">
                    <el-tag style="cursor: default;" :type="getStatusType(scope.row.status)">REJECTED</el-tag>
                  </span>

                  <span class="el-dropdown-link" v-else>
                    <el-tag style="cursor: default;" :type="getStatusType(scope.row.status)">{{
                      scope.row.status
                      }}</el-tag>
                  </span>
                </div>
              </template>
            </el-table-column>

            <el-table-column label="Accession ID" width="285" prop="accession_id" sortable="custom">
              <template #default="scope">
                <div class="name-accession cursor" v-if="
                  scope.row.accession_data && scope.row.accession_data.length
                ">
                  <span id="accession-id-blue" class="order-accession"
                    v-for="(acccession, index) in scope.row.accession_data" :key="index"
                    @click="goToCaseView(acccession.case_id)">
                    {{ acccession.accession_id }}
                  </span>
                </div>
                <div class="name-accession cursor" @click="goToCaseView(scope.row.case_id)"
                  v-else-if="scope.row.accession_id">
                  <span id="accession-id-blue" class="order-accession">
                    {{ scope.row.accession_id }}
                  </span>
                </div>
              </template>
            </el-table-column>

            <el-table-column prop="action" label="Actions" width="110" fixed="right">
              <template v-slot="scope">
                <ul class="listings__action-buttons">
                  <li @click="goToViewOrders(scope.row._id)">
                    <el-button class="view-button" title="View EMR">
                      <img class="action-active" src="@/assets/images/icons/actions/view-icon.svg" alt="icon" />
                      <img class="action-inactive" src="@/assets/images/icons/actions/view-inactive.svg" alt="icon" />
                    </el-button>
                  </li>
                </ul>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="listings listings__pagination" v-if="getFailedEmrOrders && getFailedEmrOrders.total">
          <el-pagination v-model:currentPage="page" v-model:page-size="pageSize" :page-sizes="[25, 50, 75, 100]"
            layout=" prev, pager, next, jumper, sizes, total" :total="getFailedEmrOrders.total"
            @size-change="handleSizeChange" @current-change="handleCurrentChange" />
        </div>
      </div>
      <div class="default-modal">
        <div class="archive-popup">
          <el-dialog top="25vh" width="30%" v-model="rejectPopup">
            <div class="dialog-header">
              <span class="header-part">
                <img src="@/assets/images/reason.svg" alt="icon" />
                Reason
              </span>
              <el-button size="medium" class="el-white" type="info" plain @click="rejectPopup = false">
                <img src="@/assets/images/close-icon.svg" alt="icon" /></el-button>
            </div>

            <el-row :gutter="20" class="popup-text-area pb-0">
              <el-col :span="24">
                <h4>Notes</h4>
                <el-input type="textarea" rows="2" v-model="emrNotes" placeholder="Notes"></el-input>
                <p><b>Note:</b> Minimum 3 characters is required</p>
              </el-col>
              <el-col :span="24">
                <div class="dialog-footer text-center">
                  <el-button class="blue-cancel-button" @click="rejectPopup = false">
                    CANCEL</el-button>
                  <el-button class="blue-save-button" :disabled="!haveNotes"
                    :title="haveNotes ? 'Reject EMR' : 'Notes is Required'" @click="rejectEmr" :loading="loading">
                    REJECT EMR</el-button>
                </div>
              </el-col>
            </el-row>
          </el-dialog>
        </div>
      </div>
    </div>
    <EmrOrdersExport v-if="exportReportsDialogVisisble" v-on:close="exportReportsDialogVisisble = false"
      :selected_emr_client="emr_client" :selected_hospital="hospital" :selected_physician="physician"
      :selected_string="search_string" :selected_case_type="caseType" :selected_dob="date_of_birth"
      :selected_accession="accession_id" :selected_status="selectedStatuses" :pregnancy="pregnant"
      :selected_marketer="hospital_marketer"></EmrOrdersExport>
    <ResonForValidation v-if="takeValidationReasonDialog" v-on:close="takeValidationReasonDialog = false"
      v-on:reasonSubmit="moveToValidation" title="Reason for Validation"></ResonForValidation>
    <ResonForBulkValidations v-if="bulkValidationDialog" v-on:close="bulkValidationDialog = false"
      v-on:reasonSubmit="submitBulkValidation" title="Bulk Validations" :no_of_accessions="bulkValidationData">
    </ResonForBulkValidations>
  </section>
</template>

<script>
import { defineAsyncComponent } from "vue";

import { mapGetters } from "vuex";
import moment from "moment";
import caseConstants from "@/config/constants/caseConstants";
import { emrSearchOptions } from "@/config/constants/searchConstants";
const EmrOrdersExport = defineAsyncComponent(() =>
  import("@/components/EMROrders/EmrOrdersExport")
);
import FilterHelper from "@/mixins/FilterHelper";
import caseDataHelper from "@/mixins/caseDataHelper";
import {
  successNotification,
  errorNotification,
} from "@/helpers/notifications";
import UserPermissionsHelper from "@/mixins/UserPermissionsHelper";
const ResonForValidation = defineAsyncComponent(() =>
  import("@/components/misc/ResonForChange")
);
const ResonForBulkValidations = defineAsyncComponent(() =>
  import("@/components/misc/ReasonForBulkValidations")
);
export default {
  name: "allEmrOrders",
  components: {
    EmrOrdersExport,
    ResonForValidation,
    ResonForBulkValidations,
  },
  props: {
    selectedStatuses: {
      default: [],
    },
  },
  data() {
    return {
      disabledDate: (time) => {
        return time.getTime() > Date.now();
      },
      exportReportsDialogVisisble: false,
      rejectPopup: false,
      page: 1,
      pageSize: 25,
      caseType: "",
      caseTypeMap: caseConstants.CASE_TYPE_MAP,
      caseTypes: caseConstants.CASE_TYPES_DATA,
      searchOptions: emrSearchOptions,
      loading: false,
      search_string: "",
      orderBy: "",
      orderType: "",
      date_of_birth: "",
      hospital: "",
      physician: "",
      accession_id: "",
      searchBy: "",
      emr_client: "",
      emrClients: [],
      emrNotes: "",
      hospitalsData: {},
      physiciansData: {},
      hospitalsLoading: false,
      physiciansLoading: false,
      emrClientsLoading: false,
      pregnant: "",
      hospital_marketer: [],
      marketerData: [],
      userLoading: false,
      takeValidationReasonDialog: false,
      requestValidationEMROrder: "",
      bulkValidationData: [],
      bulkValidationDialog: false,
    };
  },
  created() {
    if (this.isFacilityUser) {
      let markerFilterIndex = this.searchOptions.findIndex(
        (option) => option.value == "hospital_marketers"
      );
      if (markerFilterIndex > -1) {
        this.searchOptions[markerFilterIndex].active = false;
      }
    }
    this.searchOptions = this.searchOptions.filter((option) => option.active);
  },
  computed: {
    isFacilityUser() {
      if (this.getAuthenticatedUser && this.getAuthenticatedUser.user_type) {
        let users = [
          "HOSPITAL_PHYSICIAN",
          "HOSPITAL_ADMIN",
          "HOSPITAL_ACCOUNT_MANAGER",
          "MARKETER",
          "HOSPITAL_MARKETING_MANAGER",
          "ACCOUNT_MANAGER"
        ];
        if (users.indexOf(this.getAuthenticatedUser.user_type) !== -1) {
          return true;
        } else {
          return false;
        }
      }
      return false;
    },
    Reason() {
      if (this.emrNotes && this.emrNotes.length >= 3) {
        return true;
      }

      return false;
    },
    // isSearchByInput() {
    //   return this.searchByKey.indexOf(this.searchBy) != -1 ? true : false;
    // },
    haveNotes() {
      return this.emrNotes && this.emrNotes.trim().length >= 3;
    },
    getStatusType() {
      return (statusVal) => {
        const status = statusVal.trim();
        if (status == "ACTIVE") {
          return "default";
        } else if (status == "COMPLETED") {
          return "success";
        } else if (status == "CANCELLED") {
          return "danger";
        } else {
          return "";
        }
      };
    },
    ...mapGetters("emrOrders", [
      "getAllEMRClients",
      "getSendReportStatus",
      "getUpdateValidationStatus",
      "getBulkValidations",
      "getFailedEmrOrders",
    ]),
    ...mapGetters("physicians", ["getAllPhysicians"]),
    ...mapGetters("hospitals", ["getAllHospitals"]),
    ...mapGetters("auth", ["getAuthenticatedUser"]),
    ...mapGetters("userAccounts", ["getAllUsers"]),
    getCaseTypes() {
      return (caseTypes) => {
        return (caseTypes || []).map((e) => this.caseTypeMap[e]);
      };
    },
  },
  mixins: [FilterHelper, caseDataHelper, UserPermissionsHelper],
  async mounted() {
    await this.fetchEmrOrders();
  },
  methods: {
    async submitBulkValidation(reason) {
      try {
        let bulkValidations = [];
        for (let accession of this.bulkValidationData) {
          bulkValidations.push(accession._id);
        }
        let params = {
          status: true,
          type: "all",
          validation_reasons: [reason],
          emr_ids: bulkValidations,
        };
        await this.$store.dispatch("emrOrders/updateBulkValidations", params);
        if (this.getBulkValidations) {
          successNotification("EMR Orders moved to validation EMR Orders");
          this.bulkValidationDialog = false;
          this.bulkValidationData = [];
          await this.fetchEmrOrders();
        } else {
          errorNotification(
            "Error while moving EMR Orders to validation EMR Orders"
          );
        }
      } catch (error) {
        console.log(error);
      }
    },
    moveBulkValidation() {
      this.bulkValidationDialog = true;
    },
    handleSelectionChange(rows) {
      if (rows) {
        this.bulkValidationData = [];
        for (let caseData of rows) {
          this.bulkValidationData.push(caseData);
        }
      } else {
        this.bulkValidationData = [];
      }
    },
    async moveToValidations(validation) {
      this.requestValidationEMROrder = validation;
      this.takeValidationReasonDialog = true;
    },
    async moveToValidation(reason) {
      try {
        this.loading = true;
        let params = {
          id: this.requestValidationEMROrder,
          status: true,
          validation_reason: reason,
        };
        await this.$store.dispatch(
          "emrOrders/changeCaseValidationStatus",
          params
        );
        if (this.getUpdateValidationStatus) {
          successNotification("EMR order moved to validation EMR orders");
          await this.fetchEmrOrders();
        } else {
          errorNotification("Error while moving to validation EMR orders");
        }
        this.loading = false;
      } catch (error) {
        this.loading = false;
        console.log(error);
      }
    },
    async fetchAllUsers() {
      this.userLoading = true;

      await this.$store.dispatch("userAccounts/fetchAllUserAccounts", {
        get_all: true,
        user_type: "MARKETER",
        order_by: "first_name",
        order_type: "asc",
        status: "ACTIVE"
      });
      if (this.getAllUsers && this.getAllUsers.data) {
        this.marketerData = this.getAllUsers.data;
      }
      this.userLoading = false;
    },
    async onReportsExport() {
      this.loading = true;

      this.exportReportsDialogVisisble = true;
      this.loading = false;
    },
    onReject(emrOrder) {
      this.selectedEmr = emrOrder;
      this.rejectPopup = true;
    },
    clearInputSearch() {
      if (
        this.hospital ||
        this.physician ||
        this.date_of_birth ||
        this.caseType ||
        this.emr_client ||
        this.hospital_marketer.length
      ) {
        this.hospital = "";
        this.physician = "";
        this.date_of_birth = "";
        this.caseType = "";
        this.isSearchByInput = "";
        this.emr_client = "";
        this.hospital_marketer = [];
        this.page = 1;
        this.fetchEmrOrders(1);
      }
    },
    async fetchAllEMRClients() {
      try {
        this.emrClientsLoading = true;

        await this.$store.dispatch("emrOrders/fetchAllEMRClients", {
          get_all: true,
        });
        this.filterEmrClient();
        this.emrClientsLoading = false;
      } catch (err) {
        this.loading = false;
      }
    },
    filterEmrClient(filterValue) {
      if (filterValue && filterValue.length) {
        this.emrClients = [...this.getAllEMRClients.data].filter(
          (option) =>
            option.name.toLowerCase().indexOf(filterValue.toLowerCase()) == 0
        );
      } else {
        this.emrClients = this.getAllEMRClients.data;
      }
    },
    async fetchAllPhysicians() {
      try {
        this.physiciansLoading = true;
        await this.$store.dispatch("physicians/fetchAllPhysicians", {
          get_all: true,
        });
        this.physiciansData = JSON.parse(JSON.stringify(this.getAllPhysicians));
        this.physiciansLoading = false;
      } catch (error) {
        console.log(error);
      }
    },
    async fetchAllHospitals() {
      try {
        this.hospitalsLoading = true;
        await this.$store.dispatch("hospitals/fetchAllHospitals", {
          get_all: true,
        });
        this.hospitalsData = JSON.parse(JSON.stringify(this.getAllHospitals));
        this.hospitalsLoading = false;
      } catch (error) {
        console.log(error);
      }
    },

    onChangeSort({ order, prop }) {
      if (order && prop) {
        this.orderBy = prop;
        this.orderType = order == "ascending" ? "asc" : "desc";
      } else {
        this.orderBy = "";
        this.orderType = "";
      }
      this.fetchEmrOrders();
    },
    setQueryParamsData() {
      this.page = this.$route.query.selectedEmrPage
        ? parseInt(this.$route.query.selectedEmrPage)
        : 1;

      if (this.$route.query.search_string) {
        this.search_string = this.$route.query.search_string;
      }
      if (this.$route.query.selectedEmr) {
        this.fetchAllEMRClients();
        this.emr_client = this.$route.query.selectedEmr;
      }
      if (this.$route.query.selectedMarketer) {
        this.fetchAllUsers();
        this.hospital_marketer = this.$route.query.selectedMarketer;
      }
      if (this.$route.query.selectedEmrPhysician) {
        this.fetchAllPhysicians();
        this.physician = this.$route.query.selectedEmrPhysician;
      }
      if (this.$route.query.selectedEmrHospital) {
        this.fetchAllHospitals();
        this.hospital = this.$route.query.selectedEmrHospital;
      }
      this.search_string = this.$route.query.selectedEmrString;

      this.pageSize = this.$route.query.selectedEmrPageSize
        ? parseInt(this.$route.query.selectedEmrPageSize)
        : 25;

      if (this.$route.query.selectedEmrCaseType) {
        this.caseType = this.$route.query.selectedEmrCaseType;
      }
      if (this.$route.query.selectedEmrSearchBy) {
        this.searchBy = this.$route.query.selectedEmrSearchBy;
      }
      if (this.$route.query.selectedEmrDateOfBirth) {
        this.date_of_birth = this.$route.query.selectedEmrDateOfBirth;
      }

      if (this.$route.query.selectedEmrOrderBy) {
        this.orderBy = this.$route.query.selectedEmrOrderBy;
      }
      if (this.$route.query.selectedEmrOrderType) {
        this.orderType = this.$route.query.selectedEmrOrderType;
      }
    },
    prepareParams() {
      this.pregnant = "";
      const params = {
        page: this.page,
        limit: this.pageSize,
        is_validation_purpose: false,
      };
      if (this.search_string) {
        params.search_string = this.search_string;
      }
      if (this.date_of_birth) {
        const date_of_birth = moment(this.date_of_birth).format("YYYY-MM-DD");

        params.date_of_birth = date_of_birth;
      }
      if (this.hospital) {
        params.hospital = this.hospital;
      }
      if (this.caseType) {
        params.case_type = this.caseType;
      }
      if (this.physician) {
        params.ordering_physician = this.physician;
      }
      if (this.emr_client) {
        params.emr_client = this.emr_client;
      }
      if (this.hospital_marketer.length) {
        params.hospital_marketers = this.hospital_marketer;
      }

      if (this.orderBy && this.orderType) {
        params.order_by = this.orderBy;
        params.order_type = this.orderType;
      }
      if (this.searchBy == "Pregnancy") {
        this.pregnant = true;
        params.pregnant = true;
      }
      return params;
    },
    getAutoCompleteOrders() {
      setTimeout(() => {
        this.page = 1;
        this.fetchEmrOrders();
      }, 600);
    },
    handleSizeChange(size) {
      this.pageSize = size;
      this.page = 1;

      this.fetchEmrOrders();
    },
    handleCurrentChange(page) {
      this.page = page;

      this.fetchEmrOrders();
    },
    async fetchEmrOrders() {
      try {
        this.loading = true;
        let params = this.prepareParams();
        await this.$store.dispatch(
          "emrOrders/fetchAllNotSentEmrOrders",
          params
        );
        this.updateQueryParams(params);
        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },
    updateQueryParams(params) {
      let selectedParams = {
        selectedEmrPage: params.page,
        selectedEmrCaseType: params.case_type,
        selectedEmrHospital: params.hospital,
        selectedEmrDateOfBirth: params.date_of_birth,
        selectedEmrPhysician: params.ordering_physician,
        selectedEmrString: params.search_string,
        selectedEmrPageSize: params.limit,
        selectedStatus: params.status,
        selectedEmrOrderBy: params.order_by,
        selectedEmrOrderType: params.order_type,
        selectedEmrAccessionId: params.accession_id,
        selectedEmrSearchBy: this.searchBy || undefined,
        selectedEmr: params.emr_client,
        selectedMarketer: params.hospital_marketers,
      };
      this.updateQueryParam(this.$route.name, selectedParams);
    },
    goToViewOrders(orderId) {
      this.$router.push({
        name: "View-Case-Information",
        params: { order_id: orderId },
        query: { ...this.$route.query, redirectRoute: this.$route.name },
      });
    },
    goToCaseView(caseId) {
      this.$router.push({
        name: "CaseView",
        params: { case_id: caseId },
        query: { ...this.$route.query, redirectRoute: this.$route.name },
      });
    },
    async rejectEmr() {
      try {
        this.loading = true;
        await this.$store.dispatch("emrOrders/sendReportToEmr", {
          notes: [this.emrNotes],
          result_status: "CANCELLED",
          order_id: this.selectedEmr._id,
          emr_order_id: this.selectedEmr._id,
        });
        if (this.getSendReportStatus) {
          this.rejectPopup = false;

          successNotification("EMR rejected successfully");
          this.emrNotes = "";
          await this.fetchEmrOrders(this.page);
        } else {
          errorNotification("Error in rejecting EMR");
        }
        this.loading = false;
      } catch (err) {
        console.log(err);
        this.loading = false;
      }
    },
  },
};
</script>

<style lang="scss">
.image-fluid {
  width: 100%;
}

.validation-button {
  display: block;
  margin-bottom: -5px;

  img {
    width: 25px;
  }
}
</style>
